import { CellProps, Renderer } from 'react-table';
import { UserProfileLink } from '../../components/UserProfileLink';

type RecordType = Record<string, any>;
const BookedByRenderer: Renderer<CellProps<RecordType>> = ({ value, row }) => {
  if (value === null || value === undefined) {
    return <></>;
  }
  return (
    <UserProfileLink UserId={row.original.BookedById} DisplayName={value} />
  );
};
export default BookedByRenderer;
